export default class JobCardParser {
    static parseData(dataFromAPI, templateDataToReturn) {
        templateDataToReturn = dataFromAPI
        return templateDataToReturn
    }
}
